module.exports = __webpack_public_path__ + "static/media/ncj_bangle_0003.e6eb8944.jpg";